import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { UsernameStyleInterface, setEditId, setEditError, selectUsernameStyleById } from "../../../store/mine_craft/usernameStylesSlice";
import { updateUsernameStyle, fetchUsernameStyle } from "../../../actions/mine_craft/usernameStylesActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const id: any = useAppSelector(state => state.mineCraft.usernameStyles.editId);
  const error = useAppSelector(state => state.mineCraft.usernameStyles.editError);
  const usernameStyle = useAppSelector(state => id ? selectUsernameStyleById(state, id) : undefined);
  const params: any = { ...usernameStyle };

  useEffect(() => {
    if (id) {
      dispatch(fetchUsernameStyle(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(rawData: any) {
    const data = { ...rawData };

    handleSave(data).catch(console.error);
  }

  async function handleSave(data: UsernameStyleInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateUsernameStyle({ id, data: formData }));

    if (updateUsernameStyle.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-usernameStyle'>
        <h6 className="v-content-label">Edit UsernameStyle</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={params} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
